module.exports = __webpack_public_path__ + "static/media/notification.6a34875b.svg";